<div class="sec-title">
  <h1>Gestion</h1>
</div>
<hr>
<div class="row">
  <div class="card col-lg-6 col-md-12 me-3 mt-3">
      <div class="card-body">
        <h5 class="card-title">Gestion des utilisateurs</h5>
        <p class="card-text">Gestion des usagers qui ont accès au site.</p>
        <a routerLink="../usagers" class="btn btn-primary">Gérer les utilisateurs</a>
      </div>
  </div>
  <div class="card col-lg-6 col-md-12 me-3 mt-3">
    <div class="card-body">
      <h5 class="card-title">Gestion du gabarit Bon de Commande</h5>
      <p class="card-text">Gestion des itèmes et des prix dans le bon de commande.</p>
      <a routerLink="../bondecommande" class="btn btn-primary">Gérer le gabarit Bon de Commande</a>
    </div>
</div>

  <div class="card col-lg-6 col-md-12 me-3 mt-3">
      <div class="card-body">
        <h5 class="card-title">Gestion des soustraitants</h5>
        <p class="card-text">Gestion des soustraitants. (Informations, notes, documents)</p>
        <a routerLink="../soustraitants" class="btn btn-primary">Gérer les soutraitants</a>
      </div>
  </div>

  <div class="card col-lg-6 col-md-12 me-3 mt-3">
      <div class="card-body">
          <h5 class="card-title">Gestion des maquettes de propositions</h5>
          <a routerLink="../maquettes" class="btn btn-primary">Gérer les propositions</a>
      </div>
  </div>
</div>
<hr>